import TransactionStatus from "enums/TransactionStatus";

export interface RequestCounts {
  pending: number;
  processing: number;
  total: number;
}

/** One display rule for a count that stopped at the fetch limit, on every /my/ surface. */
export const shownCount = ({
  total,
  capped,
}: {
  total: number;
  capped: boolean;
}): string | number => (capped ? `${total}+` : total);

/** `total` is the server's `pageInfo.total`, which is exact only up to the fetch limit. */
export const requestCounts = (
  statuses: (string | null | undefined)[],
  processingStatus: TransactionStatus,
  total?: number | null,
): RequestCounts => {
  const processing = statuses.filter(
    (status) => status === processingStatus,
  ).length;
  return {
    pending: statuses.length - processing,
    processing,
    total: total ?? statuses.length,
  };
};
